<script setup lang="ts">
import * as Sentry from '@sentry/nuxt'
import * as z from 'zod'
import { Toaster } from '@/components/ui/sonner'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type') {
    if (issue.expected === 'string') {
      return { message: 'Обязательное поле' }
    }
  }
  return { message: ctx.defaultError }
})
const scrolledEnough = ref(false)
const route = useRoute()
const showSecondaryButton = computed(() => {
  return route.path === '/' && scrolledEnough.value
})
const handleScroll = useThrottleFn(() => {
  scrolledEnough.value = window.scrollY > 800
}, 100)

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
  handleScroll()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

const { error: visitError } = useLazyFetch('/api/visit', {
  method: 'POST',
  body: route.query,
})

// Обрабатываем ошибку отправки данных о визите
if (visitError.value) {
  Sentry.withScope((scope) => {
    scope.setTag('app', 'main')
    scope.setTag('action', 'track_visit')
    scope.setLevel('warning') // Ошибки трекинга не критичны
    Sentry.captureException(new Error(`Visit tracking failed: ${visitError.value?.message}`))
  })
}

const documentStore = useDocumentStore()

defineOgImageComponent('BrandLogo', {
  theme: '#019DDC',
})
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#019DDC" />
    <NuxtPage />
  </NuxtLayout>

  <ClientOnly>
    <Toaster />
    <DocumentDialog v-if="documentStore.open" />
  </ClientOnly>
  <transition name="fade-move">
    <div v-if="showSecondaryButton" class="fixed bottom-5 left-1/2 -translate-x-1/2 z-50">
      <GradientButton class="md:hidden text-base md:text-base px-2 py-4 max-w-[160px] mx-auto">
        <NuxtLink to="https://lk.nebusfinance.ru/step-first">
          <span class="text-white">Получить деньги</span>
        </NuxtLink>
      </GradientButton>
      <GetMoneyButton class="hidden md:block max-w-[300px] mx-auto" />
    </div>
  </transition>
</template>

<style>
@reference "assets/css/main.css";
/* Плавная прокрутка для нативных методов */
.text-title {
  color: #3D4D5C;
}

::-moz-selection { /* Code for Firefox */
  @apply bg-primary/30
}

::selection {
  @apply bg-primary/30
}

.fade-move-enter-active,
.fade-move-leave-active {
  transition: all 0.3s ease;
}

.fade-move-enter-from,
.fade-move-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* Для основной кнопки сохраняем оригинальную позицию */
.fixed.right-4 .fade-move-enter-from,
.fixed.right-4 .fade-move-leave-to {
  transform: translateY(20px) translateX(20px);
}

/* Для центральной кнопки корректируем анимацию */
.fixed.left-1\/2 .fade-move-enter-from,
.fixed.left-1\/2 .fade-move-leave-to {
  transform: translateY(20px) translateX(-50%);
}
</style>
